import { Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import RetryPaymentModal from "../payment-retry-confirmation-modal";
import { useSelector } from "react-redux";
import { SUBSCRIPTION_STATUSES } from "../../../../../v2/config/constant";

const PaymentRetryButton = () => {
  const { t } = useTranslation();
  const { authProfile } = useSelector((state) => state.application);

  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);

  const validDisplayStatuses = [
    SUBSCRIPTION_STATUSES.GRACE_PERIOD,
    SUBSCRIPTION_STATUSES.RENEW_FAILED,
  ];

  const visibility = validDisplayStatuses.includes(
    authProfile.subscriptionStatus
  );

  const onCloseModal = () => setShowConfirmDialog(false);

  return (
    visibility && (
      <React.Fragment>
        <Typography
          variant="body2"
          className="text-link w-fit-content"
          onClick={() => setShowConfirmDialog(true)}
        >
          {t("settingPage.retryPayment")}
        </Typography>

        {showConfirmDialog && (
          <RetryPaymentModal
            showModal={showConfirmDialog}
            setShowConfirmDialog={setShowConfirmDialog}
            onCloseModal={onCloseModal}
          />
        )}
      </React.Fragment>
    )
  );
};

export default PaymentRetryButton;
